import { useStaffAuth } from '../stores/staffAuth';

const BASE_URL =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (location.hostname === 'localhost' ? 'http://localhost/ciudadapp/api' : '/api');

export class StaffApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function apiStaff<T = unknown>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const { headers, ...rest } = options;
  const token = useStaffAuth.getState().accessToken;

  const h: Record<string, string> = {
    Accept: 'application/json',
    ...(headers as Record<string, string> | undefined),
  };
  if (!(rest.body instanceof FormData) && rest.body !== undefined) {
    h['Content-Type'] = 'application/json';
  }
  if (token) h['Authorization'] = `Bearer ${token}`;

  const res = await fetch(BASE_URL + path, { ...rest, headers: h });
  let json: any;
  try { json = await res.json(); } catch {
    throw new StaffApiError('Respuesta inválida del servidor', res.status);
  }
  if (!res.ok || json.ok === false) {
    if (res.status === 401) useStaffAuth.getState().logout();
    throw new StaffApiError(json.error || json.message || `HTTP ${res.status}`, res.status);
  }
  return json.data as T;
}
